import React, { useEffect, useCallback } from 'react'
import InitiativesSelectorDialogService from './Service'
import UserResponsesManagerService from 'smart-components/user-responses-manager/Service'

import SessionManagerService from 'smart-components/session-manager/Service'
import { useServiceState, useNotification } from 'helpers'
import IProfileInitiativeStatus from 'types/sign-in/IProfileInitiativeStatus'
import { navigate } from '@reach/router'
import { IInitiativesSelectorDialogProviderProps } from './Interfaces'
import { IUserResponses } from 'types'

const Provider: React.FC<IInitiativesSelectorDialogProviderProps> = ({ children }) => {
  const { emitError } = useNotification()
  const sessionState = useServiceState(SessionManagerService, false)
  const responsesState = useServiceState(UserResponsesManagerService, false)
  const initiativeSelectorDialogState = useServiceState(InitiativesSelectorDialogService, false)

  const onInitiativeClick = useCallback((initiative: IProfileInitiativeStatus) => {
    InitiativesSelectorDialogService.setIsDialogOpen('CLOSED_BY_USER')
    navigate(`/enterprise/${initiative.enterprise_id}/${initiative.submission_link_code}/questions`)
  }, [])

  useEffect(() => {
    async function loadInitiatives(userResponses: IUserResponses) {
      const error = await InitiativesSelectorDialogService.loadInitiativeOptions(userResponses)
      if (error) {
        emitError(error)
      }
    }
    loadInitiatives(responsesState.userResponses)
  }, [responsesState, sessionState])

  return (
    <React.Fragment>
      {children({
        state: initiativeSelectorDialogState,
        onInitiativeClick
      })}
    </React.Fragment>
  )
}

export default Provider
